import { render, staticRenderFns } from "./OfficeInformation.vue?vue&type=template&id=b872513c&scoped=true&"
import script from "./OfficeInformation.vue?vue&type=script&lang=js&"
export * from "./OfficeInformation.vue?vue&type=script&lang=js&"
import style0 from "./OfficeInformation.vue?vue&type=style&index=0&id=b872513c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b872513c",
  null
  
)

export default component.exports